'use client';
import { ddRumAction } from '@/utils/datadog';
import { DD_USE_CASES } from '@/utils/datadog/types';
import { ddActionRmTrackingActions } from '../utils/datadog/tracking-actions';
import { RewardMachineGameUrlComponent } from '../subcomponents/reward-machine-game-url/reward-machine-game-url.component';
import { ZONE_SLICE_TYPES } from '@/app/constants/zone';
import { RewardMachineInfoButton } from '../subcomponents/reward-machine-info-button/reward-machine-info-button';
import { TimeLeftUntilTomorrowComponent } from '../subcomponents/time-left-until-tomorrow';
import dynamic from 'next/dynamic';
import { getAppPlatform } from '@/logic/platform';
import { APP_PLATFORM, ROUTES } from '@/utils/constants';
import { isMobile, isTablet } from '@/utils/devices';
import { useRewardsMachineEntry, useSyncRewardMachineWelcomeModalData } from '@/hooks/use-reward-machine-entry';
import './styles/default.scss';
import { useGameLauncherEvents } from '@/hooks/use-rewards/use-game-launcher-events';
import { useRewardMachineContent } from '@/hooks/use-reward-machine-entry/use-reward-machine-content';
import { useAccountUm } from '@/hooks/use-account-um';
import { useEffect } from 'react';

const trackDDRumRMEntry = () => {
    ddRumAction(ddActionRmTrackingActions({ event: 'entryUpdate', action: 'tracking' }, DD_USE_CASES.RM_EXIT_SCREEN));
};

export const getLayoutType = (tablet: boolean, mobile: boolean) => {
    if (mobile) {
        return ZONE_SLICE_TYPES.COLLECTION;
    }

    return ZONE_SLICE_TYPES.GRID_COLLECTION;
};

// TODO https://fanduel.atlassian.net/browse/CASPROMO-13602
const TimeLeftUntilTomorrowShortLabelsComponent = ({ customServerTime }: { customServerTime?: string }) => (
    <TimeLeftUntilTomorrowComponent shortLabels={true} customServerTime={customServerTime} />
);

const getEntry = () => {};
const platform = getAppPlatform(); // TODO: read from globals

const RewardMachineEntrySelector = dynamic(
    () => import('@fanduel/rewards-hub-client').then((mod) => mod.RewardMachineEntrySelector),
    { ssr: true }
);

// TODO: the banner is interactive from while user is waiting for loggedin status

// TODO: add proper types; export from rewards-hub-client
export const RewardMachineBanner = (props: any) => {
    const { serverTime, loggedIn, timezone } = props;
    const { triggerLogin } = useAccountUm();
    const { entryData, triggerEntryCall } = useRewardsMachineEntry({
        providedServerTime: serverTime,
        loggedIn,
        timezone
    });
    const { rewardsMachineContent, fetchRewardsMachineContent, rewardsMachineContentError } = useRewardMachineContent(
        props?.rewardsMachineContent
    );

    const trackEntryUpdate = (freeSpins?: number) =>
        ddRumAction(
            ddActionRmTrackingActions(
                { event: 'entryUpdate', action: 'tracking', payload: { freeSpins } },
                DD_USE_CASES.HOMEPAGE
            )
        );

    useGameLauncherEvents({ triggerEntryCall, fetchRewardsMachineContent });
    useSyncRewardMachineWelcomeModalData(props);

    useEffect(() => {
        if (loggedIn && !entryData && !serverTime?.time) {
            triggerEntryCall();
        }
    }, []);

    const clientProps = {
        getEntry,
        triggerLogin,
        error: entryData?.error || rewardsMachineContentError,
        entryData: entryData || props.entryData,
        todayStatus: entryData?.currentDay,
        tracking: {
            exitModalViewed: () => {
                // TODO https://fanduel.atlassian.net/browse/CASPROMO-13599
                // userTrackingPush(getRewardsMachineExitModalViewed());
            }
        },
        ddRumAction: trackDDRumRMEntry,
        trackEntryUpdate,
        components: {
            // TODO: https://fanduel.atlassian.net/browse/CASPROMO-13597 wrap this function in a component
            GameLauncher: (launcherProps: any) => (
                <RewardMachineGameUrlComponent {...launcherProps} freeSpins={entryData?.currentDay?.freeSpins} />
            ),
            TimeLeftUntilTomorrowComponent: TimeLeftUntilTomorrowShortLabelsComponent,
            InfoButton: RewardMachineInfoButton
        },
        utils: {
            isMobileOnly: platform !== APP_PLATFORM.Web || (isMobile() && !isTablet(navigator?.userAgent))
        },
        constants: {
            // TODO: check and fill the routes if needed
            ROUTES
        }
    };

    const componentProps = {
        ...props,
        rewardsMachineContent
    };

    return (
        <div data-reward-machine-from-banner>
            <RewardMachineEntrySelector {...componentProps} {...clientProps} />
        </div>
    );
};
